import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import OktaAuth, { toRelativeUrl } from "@okta/okta-auth-js";
import { Security } from "@okta/okta-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Outlet, useNavigate } from "react-router";
import { theme } from ".";

import { AppProvider } from "./components/AppProvider/AppProvider";
import { oktaConfig } from "./config";

const oktaAuth = new OktaAuth(oktaConfig);
const queryClient = new QueryClient();

export const App: React.FC = () => {
  const naviguate = useNavigate();
  const restoreOriginalUri = async (
    _oktaAuth: OktaAuth,
    originalUri?: string
  ) => {
    naviguate(toRelativeUrl(originalUri || "/", window.location.origin));
  };
  const onAuthRequired = function (oktaAuth: OktaAuth) {
    oktaAuth.signInWithRedirect();
  };

  return (
    <Security
      oktaAuth={oktaAuth}
      restoreOriginalUri={restoreOriginalUri}
      onAuthRequired={onAuthRequired}
    >
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <AppProvider theme={theme}>
            <Outlet />
          </AppProvider>
        </LocalizationProvider>
      </QueryClientProvider>
    </Security>
  );
};
